export default "__VITE_ASSET__DBzUc9Ey__"